<template>
  <div v-bind:class="{ showHeaderWhite: isFixed }" class="landing-header">
    <b-navbar
      fixed="top"
      toggleable="xl"
      class="navbar-inverse"
      v-bind:class="{
        activeHeader: scrolled,
        'home-header-overlay': $route.name === 'home' && !scrolled && !isFixed,
      }"
    >
      <b-container fluid="xl" class="tpMenuCountainer">
        <router-link to="/">
          <b-navbar-brand class="header-logo logo-white">
            <!-- <img class="" src="/assets/images/homepage/LMS-logo-white.svg" /> -->
            <img
              src="/assets/images/banner/logo-white.svg"
              alt="KIPS Virtual"
              width="157"
              height="59"
            />
          </b-navbar-brand>

          <b-navbar-brand class="header-logo logo-blue">
            <img
              class="logo-blue"
              src="/assets/images/banner/logo-blue.svg"
              width="157"
              height="59"
            />
            <!-- <img
              src="data:image/svg+xml;base64,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" /> -->
          </b-navbar-brand>
        </router-link>
        <course-mega-menu class="mr-2" @opened="closeMobileMenu" />
        <router-link
          v-if="specialCourses.length > 0"
          class="no-decor fmcat activity-tab"
          to="/activities"
        >
          <span class="special-logo">
            <img
              src="/assets/images/banner/special-logo.png"
              alt=""
              width="19"
              height="20"
            />
            <span>Activities</span>
          </span>
        </router-link>
        <!-- <router-link class="no-decor fmcat header-enroll-btn" to="/category">
          <span>Programs</span>
        </router-link> -->

        <div class="top-header-cart small-show ml-auto">
          <router-link
            v-if="$route.name !== 'registration'"
            class="no-decor"
            to="/cart"
          >
            <span class="">
              <!-- <i class="fal fa-shopping-cart"></i> -->
              <svg
                width="21"
                height="25"
                viewBox="0 0 21 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.0187 24.1593H4.53553C3.19522 24.1593 2.0952 23.1531 1.97131 21.8203L0.570938 8.50368C0.514623 7.91425 0.709848 7.33608 1.1003 6.90433C1.49075 6.47634 2.05015 6.22855 2.63207 6.22855H18.9259C19.5079 6.22855 20.0635 6.47634 20.4577 6.90433C20.8482 7.33233 21.0434 7.9105 20.9908 8.49242L19.5829 21.8316C19.4628 23.1531 18.359 24.1593 17.0187 24.1593ZM2.63207 8.04941C2.54197 8.04941 2.4819 8.09446 2.44811 8.132C2.41432 8.16955 2.37302 8.23337 2.38429 8.32347L3.78466 21.6401C3.8222 22.0419 4.14507 22.3384 4.53928 22.3384H17.0225C17.4167 22.3384 17.7396 22.0456 17.7733 21.6514L19.1775 8.31221C19.185 8.23337 19.1474 8.16955 19.1099 8.132C19.0761 8.09446 19.016 8.04941 18.9259 8.04941H2.63207Z"
                  fill=""
                />
                <path
                  d="M16.1075 10.7619C15.6044 10.7619 15.199 10.3527 15.199 9.85335V6.37307C15.199 3.94026 13.2204 1.95796 10.7839 1.95796C8.35104 1.95796 6.36874 3.9365 6.36874 6.37307V9.85335C6.36874 10.3564 5.95952 10.7619 5.46019 10.7619C4.95711 10.7619 4.55164 10.3527 4.55164 9.85335V6.37307C4.54789 2.93409 7.34487 0.137104 10.7839 0.137104C14.2228 0.137104 17.0198 2.93409 17.0198 6.37307V9.85335C17.0198 10.3564 16.6106 10.7619 16.1075 10.7619Z"
                  fill=""
                />
              </svg>

              <span class="count">{{ this.totalRecordInCart }}</span>
            </span>
          </router-link>
        </div>
        <div class="menu-toggle-btn" v-bind:class="{ open: isOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <b-navbar-toggle
          target="nav-collapse"
          @click="openMenu"
        ></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav class="ml-auto" v-model="visible">
          <b-navbar-nav @click="startScroll" class="">
            <li
              @click="openMenu"
              class="special-logo"
              v-if="specialCourses.length > 0"
            >
              <img
                src="/assets/images/banner/special-logo.png"
                alt=""
                width="19"
                height="20"
              />
              <router-link class="nav-link pl-2 pl-xl-0" to="/activities"
                >Activities</router-link
              >
            </li>
            <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/"
                >Home</router-link
              >
            </li>
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/featuredCourses"
                >Featured Courses</router-link
              >
            </li> -->
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/ebookPrograms"
                ><span class="lower-case-ebook">e</span>Books</router-link
              >
            </li> -->
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/exam"
                >Entry Test Pre Test</router-link
              >
            </li> -->
            <!--             
            <li @click="openMenu"
              @mouseover="onOver('dropdownClass')"
              @mouseleave="onLeave('dropdownClass')"
            >
              <b-dropdown
                id="dropdown-nav"
                text="CLASSES"
                ref="dropdownClass"
                class="m-md-2 header_subMenu js-header-sub-menu class-menu btn-secondary-margin"
              >
                <class-menu></class-menu>
              </b-dropdown>
            </li>
            <li 
            @click="openMenu"
              @mouseover="onOver('dropdownExam')"
              @mouseleave="onLeave('dropdownExam')"
            >
              <b-dropdown
                id="dropdown-nav"
                text="EXAMS"
                ref="dropdownExam"
                class="m-md-2 header_subMenu js-header-sub-menu exam-menu"
              >
                <exam-menu></exam-menu>
              </b-dropdown>
            </li> -->
            <!-- <li @click="openMenu">
              <a class="nav-link pl-2 pl-xl-0" target="_blank" href="https://kips.edu.pk/blog/">Blogs</a>
            </li> -->
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/faq">FAQs</router-link>
            </li> -->
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/category">Free Trials</router-link>
            </li> -->
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/category">Enroll</router-link>
            </li> -->
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/blogs">Blogs</router-link>
            </li> -->
            <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/aboutUs"
                >About Us</router-link
              >
            </li>
            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/faq"
                >FAQs</router-link
              >
            </li> -->
            <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/aiMentor"
                >AI Mentor</router-link
              >
            </li>

            <!-- <li @click="openMenu">
              <router-link class="nav-link pl-2 pl-xl-0" to="/howitworks">How it works</router-link>
            </li> -->
            <!-- <li @click="openPopup">
              <a class="nav-link pl-2 pl-xl-0">Expert Advice</a>
            </li> -->
            <!-- <b-nav-item-dropdown text="Buy" right>
              <div class="dropdown-head">
                <div class="col-md-6"><span class="footer-head">Classes</span></div>
                <div class="col-md-6"><span class="footer-head">Exams</span></div>
              </div>
              <div class="sub-menu">
                <div class="col-md-6">
                  <div class="left-menu">
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        Class 9th
                      </li>
                    </b-dropdown-item>
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        Class 10th
                      </li>
                    </b-dropdown-item>
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        1st Year
                      </li>
                    </b-dropdown-item>
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        2nd Year
                      </li>
                    </b-dropdown-item>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="right-menu">
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        Medical
                      </li>
                    </b-dropdown-item>
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        Engineering
                      </li>
                    </b-dropdown-item>
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        General Prep
                      </li>
                    </b-dropdown-item>
                    <b-dropdown-item href="#">
                      <li>
                        <span class="purple-dot"></span>
                        Foreign Tests
                      </li>
                    </b-dropdown-item>
                  </div>
                </div>
              </div>
            </b-nav-item-dropdown> -->
            <!-- <li @click="openMenu">
              <router-link class="nav-link text-no-transform" to="/#sectionFaq">FAQs</router-link>
            </li>
            <li @click="openMenu">
              <router-link class="nav-link" to="/#sectionDownloadApp">Download App</router-link>
            </li>
            <li @click="openMenu">
              <a class="nav-link" target="_blank" href="https://www.kipspublications.com/">Publications</a>
            </li> -->

            <!-- <li @mouseover="onOver('dropdownSecond')" @mouseleave="onLeave('dropdownSecond')">
              <b-dropdown id="dropdown-nav" text="BUY" ref="dropdownSecond" class="m-md-2 header_subMenu js-header-sub-menu class-menu">
                <section class="test-buy">
                  <ul>
                    <li @click="openMenu" class="">
                      <router-link class="buy_subMenuItem nav-link" to="/exam">Exam</router-link>
                    </li>
                    <li @click="openMenu" class="">
                      <router-link class="buy_subMenuItem nav-link" to="/class">Class</router-link>
                    </li>
                  </ul>
                </section>
              </b-dropdown>
            </li> -->
          </b-navbar-nav>
          <!-- <div class="top-header-cart">
            <router-link class="no-decor" to="/cart">
              <span>
                <i class="fas fa-shopping-cart"></i>
                <span class="count">{{ this.totalRecordInCart }}</span>
              </span>
            </router-link>
          </div> -->
          <div class="top-header-cart large-show mr-2">
            <router-link
              v-if="$route.name !== 'registration'"
              class="no-decor"
              to="/cart"
            >
              <span>
                <!-- <i class="fal fa-shopping-cart"></i> -->
                <svg
                  width="21"
                  height="25"
                  viewBox="0 0 21 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.0187 24.1593H4.53553C3.19522 24.1593 2.0952 23.1531 1.97131 21.8203L0.570938 8.50368C0.514623 7.91425 0.709848 7.33608 1.1003 6.90433C1.49075 6.47634 2.05015 6.22855 2.63207 6.22855H18.9259C19.5079 6.22855 20.0635 6.47634 20.4577 6.90433C20.8482 7.33233 21.0434 7.9105 20.9908 8.49242L19.5829 21.8316C19.4628 23.1531 18.359 24.1593 17.0187 24.1593ZM2.63207 8.04941C2.54197 8.04941 2.4819 8.09446 2.44811 8.132C2.41432 8.16955 2.37302 8.23337 2.38429 8.32347L3.78466 21.6401C3.8222 22.0419 4.14507 22.3384 4.53928 22.3384H17.0225C17.4167 22.3384 17.7396 22.0456 17.7733 21.6514L19.1775 8.31221C19.185 8.23337 19.1474 8.16955 19.1099 8.132C19.0761 8.09446 19.016 8.04941 18.9259 8.04941H2.63207Z"
                    fill=""
                  />
                  <path
                    d="M16.1075 10.7619C15.6044 10.7619 15.199 10.3527 15.199 9.85335V6.37307C15.199 3.94026 13.2204 1.95796 10.7839 1.95796C8.35104 1.95796 6.36874 3.9365 6.36874 6.37307V9.85335C6.36874 10.3564 5.95952 10.7619 5.46019 10.7619C4.95711 10.7619 4.55164 10.3527 4.55164 9.85335V6.37307C4.54789 2.93409 7.34487 0.137104 10.7839 0.137104C14.2228 0.137104 17.0198 2.93409 17.0198 6.37307V9.85335C17.0198 10.3564 16.6106 10.7619 16.1075 10.7619Z"
                    fill=""
                  />
                </svg>

                <span class="count">{{ this.totalRecordInCart }}</span>
              </span>
            </router-link>
          </div>
          <div class="top-header-btn">
            <a class="header-login-btn" :href="gotoPortal()">
              <!-- <template v-if="isClient">
                <template v-if="hasToken">Portal</template>
<template v-else>Log in</template>
</template>
<template v-else>-------</template> -->
              <template>Login</template>
            </a>
          </div>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
import classMenu from "../../views/course/class/menu";
import courseMegaMenu from "../../components/CourseMegaMenu";
import examMenu from "../../views/course/exam/menu";
import baseComponent from "../../components/baseComponent";
import { mapGetters, mapActions } from "vuex";
import {
  cart as cartStoreKeys,
  auth as authStoreKeys,
  headerType as headerTypeStoreKeys,
  specialCourses as specialCoursesStoreKeys,
} from "../../store/keys";
import { appConstants } from "../../common/constants";
import { blogs as blogsStoreKeys } from "../../store/keys";
export default {
  extends: baseComponent,
  components: {
    classMenu: classMenu,
    examMenu: examMenu,
    courseMegaMenu: courseMegaMenu,
  },
  data() {
    return {
      isOpen: false,
      isScroll: false,
      visible: false,
    };
  },
  mounted() {
    this.getSpecialCourses();
    // this.fetch_Blogs()
    // const script = document.createElement("script");
    // script.setAttribute("src", "https://assets.calendly.com/assets/external/widget.js");
    // document.head.appendChild(script);
  },
  async serverPrefetch() {
    return this.getSpecialCourses();
  },
  computed: {
    ...mapGetters(cartStoreKeys.namespace, cartStoreKeys.getters),
    ...mapGetters(authStoreKeys.namespace, authStoreKeys.getters),
    ...mapGetters(headerTypeStoreKeys.namespace, headerTypeStoreKeys.getters),
    ...mapGetters(
      specialCoursesStoreKeys.namespace,
      specialCoursesStoreKeys.getters,
    ),
    ...mapGetters(blogsStoreKeys.namespace, blogsStoreKeys.getters),
  },
  props: ["scrolled"],
  methods: {
    ...mapActions(blogsStoreKeys.namespace, blogsStoreKeys.actions),
    ...mapActions(
      specialCoursesStoreKeys.namespace,
      specialCoursesStoreKeys.actions,
    ),
    gotoPortal() {
      return `${process.env.VUE_APP_PORTAL_URL}/dashboard`;
    },
    openMenu() {
      this.isOpen = !this.isOpen;
      this.isOpen
        ? document.body.classList.add("no-scroll")
        : document.body.classList.remove("no-scroll");
    },
    closeMobileMenu() {
      if (!window.matchMedia("(max-width: 1199px)").matches) return;
      this.visible = false;
      this.isOpen = false;
      document.body.classList.remove("no-scroll");
    },
    hideScroll() {
      this.isScroll = !this.isScroll;
      this.isScroll
        ? document.body.classList.add("no-scroll")
        : document.body.classList.remove("no-scroll");
    },
    startScroll() {
      this.isScroll = false;
      this.isScroll
        ? document.body.classList.add("no-scroll")
        : document.body.classList.remove("no-scroll");
    },
    onOver(dropdownValue) {
      let customRef = this.$refs[dropdownValue];
      customRef.visible = true;
    },
    onLeave(dropdownValue) {
      let customRef = this.$refs[dropdownValue];
      customRef.visible = false;
    },
    getSpecialCourses(pagingMode) {
      return this.get_SpecialCourses({
        data: {
          CourseListFilter: 2,
          // CourseGroupId: this.selectedCourseGroupCategory.Id,
          ProgramCategoryId: appConstants.enums.programCategory.All,
          ApplyDefaultTagFilter: false,
          PageNumber: 1,
          PageSize: 12,
        },
        config: {
          loader: {
            show: true,
            id: "examCoursesLoader",
          },
        },
        pagingMode: pagingMode,
      })
        .then((response) => {
          // this.showRecordsNotFound = true;
          // this.coursePaging.pageNumber = response.PageNumber;
        })
        .catch((ex) => {
          this.$alertError(ex.message);
        });
    },
    openPopup() {
      Calendly.initPopupWidget({
        url: "https://calendly.com/kipsvirtual/ask-an-expert",
      });
      return false;
    },
  },
};
</script>
<style scoped>
.navbar-inverse.home-header-overlay {
  background-color: rgba(40, 43, 95, 0.25);
}

.lower-case-ebook {
  text-transform: lowercase !important;
}
</style>
